<template>
  <div class="list">
    <el-card class="searchCard" shadow="never">
      <el-col class="marginBtm">
        <el-form :inline="true" :model="search_form">
          <el-form-item label="核算月份">
            <el-date-picker
              v-model="comeTime"
              type="monthrange"
              align="right"
              unlink-panels
              range-separator="-"
              start-placeholder="开始月份"
              end-placeholder="结束月份"
              @change="dateChange"
              value-format="yyyy-MM"
              :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
          <auth-button opt="search" label="查询" @click.native="search"></auth-button>
          <auth-button
            opt="export"
            :plain="true"
            icon="el-icon-download"
            @click.native="exportFile"
            :loading="exportLoading"
            label="导出"></auth-button>
        </el-form>
      </el-col>
    </el-card>
    <el-card class="tableCard" shadow="never">
      <el-table border style="width: 100%;" v-loading="loading" :data="list" max-height="600">
        <el-table-column
          prop="month"
          label="核算月份"
          align="center">
        </el-table-column>
        <el-table-column
          prop="agentId"
          label="代理商编号"
          align="center">
        </el-table-column>
        <el-table-column
          prop="agentName"
          label="代理商名称"
          align="center">
        </el-table-column>
        <el-table-column
          prop="effectCount"
          label="有效交易笔数"
          align="center">
        </el-table-column>
        <el-table-column
          label="有效交易金额"
          align="center">
          <template slot-scope="scope">
            <span>{{ (scope.row.effectAmount/100).toFixed(2) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="dailyEffectCount"
          label="月日均有效交易笔数"
          align="center">
        </el-table-column>
        <el-table-column
          prop="dailyIncreaseCount"
          label="月日均增量笔数"
          align="center">
        </el-table-column>
        <el-table-column
          prop="activeMerchantNum"
          label="活跃商户数"
          align="center">
        </el-table-column>
        <el-table-column
          label="增量笔数奖励"
          align="center">
          <template slot-scope="scope">
            <span>{{ (scope.row.increaseReward/100).toFixed(2) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="活跃商户奖励"
          align="center">
          <template slot-scope="scope">
            <span>{{ (scope.row.activeReward/100).toFixed(2) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="手续费奖励"
          align="center">
          <template slot-scope="scope">
            <span>{{ (scope.row.feeReward/100).toFixed(2) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="6月特别增量奖励"
          align="center">
          <template slot-scope="scope">
            <span>{{ (scope.row.specialReward/100).toFixed(2) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="突破奖励"
          align="center">
          <template slot-scope="scope">
            <span>{{ (scope.row.breakReward/100).toFixed(2) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="link奖励"
          align="center">
          <template slot-scope="scope">
            <span>{{ (scope.row.linkBreakReward/100).toFixed(2) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="增量奖励(21年)"
          align="center">
          <template slot-scope="scope">
            <span>{{ (scope.row.increaseAward2021/100).toFixed(2) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="手续费奖励(21年)"
          align="center">
          <template slot-scope="scope">
            <span>{{ (scope.row.feeAward2021/100).toFixed(2) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="总奖励金额"
          align="center">
          <template slot-scope="scope">
            <span>{{ (scope.row.totalReward/100).toFixed(2) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="140"
          fixed="right"
          align="center">
          <template slot-scope="scope">
            <auth-button
              opt="details"
              type="text"
              label="查看奖励发放"
              @click.native="checkReward(scope.row)"></auth-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-col :span="24" class="btm-action">
      <el-pagination
        v-if="paginations.total>0"
        class="pagination"
        :page-sizes="paginations.pageSizes"
        :page-size="paginations.pageSize"
        :layout="paginations.layout"
        :total="paginations.total"
        :pageNum="paginations.pageNum"
        @current-change="onChangeCurrentPage">
      </el-pagination>
    </el-col>
    <el-dialog
      title="查看奖励发放"
      :visible.sync="checkRewardVisible"
      width="50%">
      <div class="rewardbtn">
        <!-- <auth-button opt="apply_reward" type="text" @click.native="applyReward" v-if="hasData" label="申请奖励"></auth-button> -->
      </div>
      <el-table
        border
        :data="RewardList"
        :span-method="objectSpanMethod"
        style="width: 100%">
        <el-table-column
          prop="month"
          align="center"
          label="核算月份">
        </el-table-column>
        <el-table-column
          align="center"
          label="发放月份">
          <template slot-scope="scope">
            <span>{{ scope.row.futureMonth }}{{ '('+'T+' + scope.row.t +')' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="发放金额">
          <template slot-scope="scope">
            <span>{{ (scope.row.amount/100).toFixed(2) }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column
          align="center"
          label="申请奖励">
          <template slot-scope="scope">
            <auth-button v-if="scope.row.isApply === 1" opt="apply_details" type="text" @click.native="lookUpDetail(scope.row)" label="查看申请详情"></auth-button>
            <span v-else>-</span>
          </template>
        </el-table-column> -->
        <el-table-column
          align="center"
          label="奖励是否发放">
          <template slot-scope="scope">
            <span>{{ scope.row.isUse | isUse }}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog
      :title="rewardType === 1 ? '申请奖励' : '查看申请详情'"
      :visible.sync="applyRewardVisible"
      width="750px">
      <div>
        <el-form :model="rewardForm" :rules="rules" ref="rewardForm" label-width="120px" class="demo-ruleForm">
          <el-form-item label="核算月份" required>
            <span v-if="rewardType===1">{{ rewardForm.month }}</span>
            <span v-if="rewardType===2">{{ detailForm.month }}</span>
          </el-form-item>
          <el-form-item label="发放月份" prop="futureMonth" v-if="rewardType===1">
            <el-checkbox-group v-model="rewardForm.futureMonth" @change="computedParam">
              <el-checkbox v-for="item in fMonth" :label="item.futureMonth" :key="item.futureMonth" :disabled="item.isApply ===1">{{ item.futureMonth }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="发放月份" required v-if="rewardType===2">
            <span>{{ detailForm.applyMonths }}</span>
          </el-form-item>
          <el-form-item label="发放金额" required >
            <span v-if="rewardType===1">{{ amount }}元</span>
            <span v-if="rewardType===2">{{ detailForm.amount }}元</span>
          </el-form-item>
          <el-form-item label="发票信息" required>
            <div v-if="rewardType===1">
              <auth-button opt="entry_invoice" type="text" @click.native="writeInvoice" v-if="!rewardForm.invoiceId" label="发票录入"></auth-button>
              <span v-if="rewardForm.invoiceId">发票ID：{{ rewardForm.invoiceId }}</span>
              <div class="red" v-if="tipShow">请录入发票信息</div>
            </div>
            <div v-if="rewardType===2">
              <auth-button opt="invoice_details" type="text" @click.native="lookInvoiceDetail" label="查看发票信息"></auth-button>
            </div>
            <div>代理商申请奖励前需开设好发票并邮寄出，方可申请奖励，注意发票金额与发放金额一致</div>
          </el-form-item>
          <el-form-item label="备注">
            <el-input class="form-input" v-model="rewardForm.remark" placeholder="请输入备注信息" clearable v-if="rewardType===1" />
            <el-input class="form-input" v-model="detailForm.remark" v-if="rewardType===2" disabled />
          </el-form-item>
          <el-form-item v-if="rewardType===1">
            <el-button style="margin-left:150px" @click="applyRewardVisible=false">取消</el-button>
            <el-button type="primary" @click="submitApplyReward">确认</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <el-dialog
      :title="invoiceType === 1 ? '发票录入' : '发票详情'"
      :visible.sync="writeRewardVisible"
      @close="clearForm"
      width="750px">
      <div>
        <el-form :model="invoiceForm" :rules="rules" ref="invoiceForm" label-width="120px" class="demo-ruleForm">
          <el-form-item label="发票金额" prop="inputAgentInvoiceAmount">
            <el-input class="form-input" v-model="invoiceForm.inputAgentInvoiceAmount" clearable :disabled="invoiceType === 2" />
          </el-form-item>
          <el-form-item label="发票代码" prop="inputAgentInvoiceCode">
            <el-input class="form-input" v-model="invoiceForm.inputAgentInvoiceCode" clearable :disabled="invoiceType === 2" />
          </el-form-item>
          <el-form-item label="发票号" prop="inputAgentInvoiceNo">
            <el-input class="form-input" v-model="invoiceForm.inputAgentInvoiceNo" clearable :disabled="invoiceType === 2" />
          </el-form-item>
          <el-form-item label="税率" prop="inputAgentTaxRatio">
            <el-input class="form-input" v-model="invoiceForm.inputAgentTaxRatio" clearable :disabled="invoiceType === 2" @change="settInputAgentTax">
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
          <el-form-item label="税额" prop="inputAgentTax">
            <el-input class="form-input" v-model="invoiceForm.inputAgentTax" disabled />
          </el-form-item>
          <el-form-item label="开票时间" prop="inputAgentInvoiceTime">
            <el-date-picker
              v-model="invoiceForm.inputAgentInvoiceTime"
              :disabled="invoiceType === 2"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              type="date">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="发票内容" prop="inputAgentContent">
            <el-input class="form-input" v-model="invoiceForm.inputAgentContent" clearable :disabled="invoiceType === 2" />
          </el-form-item>
          <el-form-item label="快递单号" prop="inputAgentTrackingNo">
            <el-input class="form-input" v-model="invoiceForm.inputAgentTrackingNo" clearable :disabled="invoiceType === 2" />
          </el-form-item>
          <el-form-item label="发票照片" prop="AgentInvoiceImg">
            <VueImgInputer
              v-model="invoiceForm.AgentInvoiceImg"
              theme="light"
              accept="image/*"
              @onChange="handleUpload('invoicePic')"
              v-loading="isPicUploading"
              placeholder="点击上传"
              :max-size="picMaxSize"
              :imgSrc="invoicePicPath"
              :readonly="invoiceType === 2"
            ></VueImgInputer>
            <div style="cursor: pointer; text-decoration: underline;" v-if="invoicePicPath" @click="invoiceImgDialogVisible = true">点击查看大图</div>
            <div style="color: #F56C6C;" v-if="invoiceType === 1">注：发票图片不得超过3M</div>
          </el-form-item>
          <el-form-item label="备注">
            <el-input
              class="form-input"
              maxlength="100"
              v-model="invoiceForm.inputInvoiceRemark"
              clearable
              placeholder="请输入备注信息"
              :disabled="invoiceType === 2" />
          </el-form-item>
          <el-form-item v-if="invoiceType === 1">
            <el-button style="margin-left:150px" @click="writeRewardVisible=false">取消</el-button>
            <el-button type="primary" @click="submitInvoice">确认</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <!-- 发票图片预览dialog -->
    <el-dialog
      :visible.sync="invoiceImgDialogVisible"
      width="50%"
      center>
      <img style="width: 100%;" :src="invoicePicPath">
    </el-dialog>
  </div>
</template>

<script>
import qs from 'qs'
import VueImgInputer from 'vue-img-inputer'
import { getRewardList, exportReward, getStageList, queryInvoiceDetail, applyRewardDetail, writeInvoiceInfo, uploadInvoiceImage, applyReward } from '@/api/activity'

export default {
  name: 'AplusReward',
  components: {
    VueImgInputer
  },
  data () {
    const twoDecimalReg = /^0{1}([.]\d{1,2})?$|^[1-9]\d*([.]{1}[0-9]{1,2})?$/
    return {
      comeTime: [],
      search_form: {
        startMonth: '', // 开始time
        endMonth: '', // 结束time
        pageNo: 1,
        pageSize: 10,
        count: 0
      },
      pickerOptions: {
        shortcuts: [{
          text: '本月',
          onClick (picker) {
            picker.$emit('pick', [new Date(), new Date()])
          }
        }, {
          text: '今年至今',
          onClick (picker) {
            const end = new Date()
            const start = new Date(new Date().getFullYear(), 0)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近六个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setMonth(start.getMonth() - 6)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      rules: {
        inputAgentInvoiceAmount: [
          { required: true, message: '请输入发票金额', trigger: 'blur' },
          { pattern: twoDecimalReg, message: '发票金额最多2位小数' }
        ],
        inputAgentInvoiceCode: [
          { required: true, message: '请输入发票代码', trigger: 'blur' },
          { max: 12, message: '请输入不超过12位的发票代码', trigger: 'blur' }
        ],
        inputAgentInvoiceNo: [
          { required: true, message: '请输入发票号', trigger: 'blur' },
          { len: 8, message: '请输入8位的发票号', trigger: 'blur' }
        ],
        inputAgentTaxRatio: [
          { required: true, message: '请输入税率', trigger: 'blur' },
          { pattern: twoDecimalReg, message: '税率最多2位小数' }
        ],
        inputAgentInvoiceTime: [
          { required: true, message: '请选择时间', trigger: 'change' }
        ],
        inputAgentContent: [
          { required: true, message: '请输入发票内容', trigger: 'blur' },
          { max: 20, message: '请输入不超过20位的发票内容', trigger: 'blur' }
        ],
        inputAgentTrackingNo: [
          { required: true, message: '请输入快递单号', trigger: 'blur' },
          { max: 20, message: '请输入不超过20位的快递单号', trigger: 'blur' }
        ],
        AgentInvoiceImg: [
          { required: true, message: '请上传发票照片' }
        ],
        futureMonth: [
          { required: true, message: '请选择发放月份', trigger: 'change' }
        ]
      },
      loading: false,
      exportLoading: false,
      checkRewardVisible: false,
      applyRewardVisible: false,
      writeRewardVisible: false,
      isPicUploading: false,
      invoiceImgDialogVisible: false,
      hasData: true,
      selectedAwardId: '',
      picMaxSize: 1024 * 3,
      RewardList: [], // 查看奖励列表发放数据
      list: [], // 列表页表格数据
      fMonth: [], // 发放月份
      amount: 0, // 发放金额
      rewardType: 1, // 申请奖励类型 1-申请奖励 2-查看申请奖励详情
      invoiceType: 1, // 申请奖励类型 1-发票录入 2-发票详情
      checkAmount: [], // 选中的发放月份对应的钱数
      checkStageIds: [], // 选中的发放月份对应的stageIds
      tipShow: false, // 发票是否已录入
      invoicePicPath: '', // 图片路径
      rewardForm: {}, // 申请奖励提交信息
      detailForm: {}, // 查看奖励详情信息
      invoiceForm: { // 发票提交信息
        inputAgentInvoiceAmount: '',
        inputAgentInvoiceCode: '',
        inputAgentInvoiceNo: '',
        inputAgentTaxRatio: '',
        inputAgentTax: '',
        inputAgentInvoiceTime: '',
        inputAgentContent: '',
        inputAgentTrackingNo: '',
        AgentInvoiceImg: '',
        inputInvoiceRemark: ''
      },
      paginations: {
        pageNum: 1,
        total: 0,
        pageSize: 10,
        pageSizes: [10],
        layout: 'total, prev, pager, next, jumper'
      }
    }
  },
  mounted () {
    this.getList()
  },
  filters: {
    isUse (val) {
      let result
      switch (val) {
        case 0:
          result = '否'
          break
        case 1:
          result = '是'
          break
      }
      return result
    }
  },
  watch: {
    checkAmount (val) {
      let money = 0
      val.forEach(item => {
        money += Number(item)
      })
      this.amount = (money / 100).toFixed(2)
    },
    checkStageIds (val) {
      return val
    }
  },
  methods: {
    // 日期选择器change事件
    dateChange (value) {
      if (value !== null) {
        this.search_form.startMonth = value[0]
        this.search_form.endMonth = value[1]
      } else {
        this.search_form.startMonth = ''
        this.search_form.endMonth = ''
      }
    },
    // 获取列表数据
    getList () {
      this.loading = true
      let param = this.formatSearch(this.search_form)
      param = qs.stringify(param)
      getRewardList(param).then((data) => {
        if (parseInt(data.error_code) !== 0) {
          this.$message({
            showClose: true,
            message: data.error_msg,
            type: 'error'
          })
          this.loading = false
          this.list = []
        } else {
          this.loading = false
          const res = data.data
          this.list = res.data
          this.paginations.total = res.totalCount
          this.search_form.count = res.totalCount
        }
      })
    },
    // 查询列表
    search () {
      // 当点击查询时，显示第一页
      this.search_form.pageNo = 1
      // 让页码数回归到1
      this.paginations.total = 0
      this.getList()
    },
    // 导出文件
    exportFile () {
      // eslint-disable-next-line no-unused-expressions
      this.paginations.total > 0
        ? (this.exportLoading = true, this.exportList())
        : this.$message({ showClose: true, message: '暂无数据可以导出', type: 'info' })
    },
    exportList () {
      [this.search_form.startMonth, this.search_form.endMonth] = this.comeTime
      const data = qs.stringify(Object.assign({}, this.formatSearch(this.search_form)))
      exportReward(data).then(res => {
        this.exportLoading = false
        const url = window.URL.createObjectURL(res)
        const link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.setAttribute('download', '奖励.xlsx')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      })
    },
    // 改变当前页事件
    onChangeCurrentPage (page) {
      const totalCount = this.search_form.count
      this.search_form.pageNo = page
      this.search_form.Count = totalCount
      this.getList()
    },
    // 查看奖励发放
    checkReward (row) {
      this.selectedAwardId = row.awardId
      this.checkRewardVisible = true
      this.checkRewardList(row.awardId)
    },
    checkRewardList (awardId) {
      let param = {
        id: awardId
      }
      param = qs.stringify(param)
      getStageList(param).then((data) => {
        if (parseInt(data.error_code) !== 0) {
          this.hasData = false
          this.$message({
            showClose: true,
            message: data.error_msg,
            type: 'error'
          })
        } else {
          this.RewardList = data.data.data
          this.hasData = !this.RewardList.every(item => {
            return item.isApply === 1
          })
          this.hasData = this.RewardList.every(item => {
            return item.isAudit === 1
          })
        }
      })
    },
    // 弹窗内申请奖励
    applyReward () {
      if (this.RewardList.length > 0) {
        this.rewardForm = {
          month: this.RewardList[0].month,
          amount: this.RewardList.map(item => (item.isApply === 0 && item.amount)),
          stageIds: this.RewardList.map(item => (item.isApply === 0 && item.stageId)).filter(item => item !== false),
          futureMonth: this.RewardList.map(item => (item.isApply === 0 && item.futureMonth)).filter(item => item !== false),
          obj: this.RewardList.map(item => {
            return {
              futureMonth: item.futureMonth,
              amount: item.amount,
              stageId: item.stageId
            }
          })
        }
        this.fMonth = this.RewardList.map(item => {
          return {
            futureMonth: item.futureMonth,
            isApply: item.isApply
          }
        })
        this.checkAmount = [...this.rewardForm.amount]
        this.checkStageIds = [...this.rewardForm.stageIds]
        this.rewardType = 1
        this.tipShow = false
        this.applyRewardVisible = true
      } else {
        this.hasData = false
      }
    },
    // 点击查看详情
    lookUpDetail (row) {
      let param = {
        applyId: row.applyId
      }
      param = qs.stringify(param)
      applyRewardDetail(param).then((data) => {
        if (parseInt(data.error_code) !== 0) {
          this.$message({
            showClose: true,
            message: data.error_msg,
            type: 'error'
          })
        } else {
          this.rewardType = 2
          this.detailForm = data.data.data
          this.detailForm.amount = Number(this.detailForm.amount / 100).toFixed(2)
          this.applyRewardVisible = true
        }
      })
    },
    // 发票录入
    writeInvoice () {
      this.invoiceType = 1
      if (!this.rewardForm.invoiceId) {
        this.invoicePicPath = ''
      }
      this.writeRewardVisible = true
    },
    // 点击查看发票详情
    lookInvoiceDetail () {
      let param = {
        invoiceId: this.detailForm.invoiceId
      }
      param = qs.stringify(param)
      queryInvoiceDetail(param).then((data) => {
        if (parseInt(data.error_code) !== 0) {
          this.$message({
            showClose: true,
            message: data.error_msg,
            type: 'error'
          })
        } else {
          this.invoiceForm = data.data.data
          this.invoicePicPath = data.data.data.agentInvoiceImg
          this.invoiceForm.inputAgentInvoiceAmount = (Number(this.invoiceForm.inputAgentInvoiceAmount) / 100).toFixed(2)
          this.invoiceForm.inputAgentTaxRatio = (Number(this.invoiceForm.inputAgentTaxRatio) / 10000).toFixed(2)
          this.invoiceForm.inputAgentTax = (Number(this.invoiceForm.inputAgentTax) / 100000000).toFixed(2)
          this.invoiceType = 2
          this.writeRewardVisible = true
        }
      })
    },
    // 根据发票面值和税率计算税额
    settInputAgentTax () {
      if (this.invoiceForm.inputAgentInvoiceAmount && this.invoiceForm.inputAgentTaxRatio) {
        // 税额  = 发票面值/（1+税率）* 税率
        const ratio = this.invoiceForm.inputAgentTaxRatio / 100
        this.invoiceForm.inputAgentTax = parseFloat(Number(this.invoiceForm.inputAgentInvoiceAmount / (1 + ratio) * ratio).toFixed(2))
      }
    },
    // 发票录入提交
    submitInvoice () {
      this.$refs.invoiceForm.validate((valid) => {
        if (valid) {
          let param = Object.assign({}, this.invoiceForm)
          param.inputAgentInvoiceAmount = Number(param.inputAgentInvoiceAmount * 100).toFixed(0)
          param.inputAgentTaxRatio = Number(param.inputAgentTaxRatio * 10000).toFixed(0)
          param.inputAgentTax = Number(param.inputAgentTax * 100000000).toFixed(0)
          param = qs.stringify(param)
          writeInvoiceInfo(param).then((data) => {
            if (parseInt(data.error_code) !== 0) {
              this.$message({
                showClose: true,
                message: data.error_msg,
                type: 'error'
              })
            } else {
              this.rewardForm.invoiceId = data.data
              this.writeRewardVisible = false
              this.tipShow = false
            }
          })
        }
      })
    },
    // 上传图片
    handleUpload (type) {
      this.isPicUploading = true
      const reader = new FileReader()
      reader.readAsDataURL(this.invoiceForm.AgentInvoiceImg)
      reader.onload = () => {
        let file = reader.result
        this.invoicePicPath = file
        file = file.split('base64,')
        let data = {
          base64pic: file[1],
          filename: this.invoiceForm.AgentInvoiceImg.name
        }
        data = qs.stringify(data)
        uploadInvoiceImage(data).then(response => {
          this.isPicUploading = false
          if (parseInt(response.error_code) === 0) {
            this.invoiceForm.AgentInvoiceImg = response.imagePath
            this.invoicePicPath = response.showPath
            this.$message({
              message: '发票图片上传成功',
              type: 'success'
            })
          } else {
            this.$message({
              message: response.error_msg,
              type: 'error'
            })
          }
        })
      }
    },
    // 选择发放月份计算money
    computedParam (val) {
      const amt = []
      const stageIds = []
      if (val.length > 0) {
        val.forEach(item => {
          this.rewardForm.obj.length > 0 && this.rewardForm.obj.forEach(ele => {
            if (ele.futureMonth === item) {
              amt.push(ele.amount)
              stageIds.push(ele.stageId)
            }
          })
        })
        this.checkAmount = [...amt]
        this.checkStageIds = [...stageIds]
      } else {
        this.checkAmount = []
      }
    },
    // 提交申请奖励资料
    submitApplyReward () {
      this.$refs.rewardForm.validate((valid) => {
        if (valid) {
          if (!this.rewardForm.invoiceId) {
            this.tipShow = true
          } else {
            this.tipShow = false
            let param = {
              awardId: this.selectedAwardId,
              stageIds: this.checkStageIds.join(),
              amount: (this.amount * 100).toFixed(0),
              invoiceId: this.rewardForm.invoiceId,
              remark: this.rewardForm.remark
            }
            param = qs.stringify(param)
            applyReward(param).then(res => {
              if (parseInt(res.error_code) === 0) {
                this.$message({
                  message: '申请成功',
                  type: 'success'
                })
                this.applyRewardVisible = false
                // 刷新奖励发放列表信息
                this.checkRewardList(this.selectedAwardId)
              } else {
                this.$message({
                  message: res.error_msg,
                  type: 'error'
                })
              }
            })
          }
        }
      })
    },
    // 合并行
    objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
      const num = this.RewardList.length
      if (columnIndex === 0) {
        if (rowIndex === 0) {
          return [num, 1]
        } else if (rowIndex === num) {
          return [1, 1]
        } else {
          return [0, 0]
        }
      }
    },
    // 清除对象中无值属性
    formatSearch (search) {
      var data = Object.assign({}, search)
      for (var s in data) {
        if (!data[s] && data[s] !== 0) {
          delete data[s]
        }
      }
      return data
    },
    // 发票详情关闭时 清空信息
    clearForm () {
      this.invoiceForm = {
        inputAgentInvoiceAmount: '',
        inputAgentInvoiceCode: '',
        inputAgentInvoiceNo: '',
        inputAgentTaxRatio: '',
        inputAgentTax: '',
        inputAgentInvoiceTime: '',
        inputAgentContent: '',
        inputAgentTrackingNo: '',
        AgentInvoiceImg: '',
        inputInvoiceRemark: ''
      }
      this.invoicePicPath = ''
      this.$nextTick(() => {
        this.$refs.invoiceForm.clearValidate()
      })
    }
  }
}
</script>

<style scoped>
    .pagination{
        margin-top: 20px;
        text-align: center;
    }
    .rewardbtn {
        position: absolute;
        right:50px;
        top:10px;
    }
    .form-input {
        width: 450px;
    }
    .red {
        color:#F56C6C
    }
</style>
